import axios from "axios";
import { getApiUrlWithVersion } from "./environmentService";
import { getAuthUser } from "./authService";

export interface PersonalAccessToken {
  id: number;
  name: string;
  token?: string; // only present on create response
  user_email: string;
  last_used_at: string | null;
  revoked: boolean;
  multi_tenant: boolean;
  created_at: string;
}

class PersonalAccessTokenService {
  private getAuthHeaders() {
    return {
      Authorization: getAuthUser()?.accessToken,
    };
  }

  async list(): Promise<PersonalAccessToken[]> {
    const response = await axios.get(
      `${getApiUrlWithVersion()}/personal_access_tokens`,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async create(name: string): Promise<PersonalAccessToken> {
    const response = await axios.post(
      `${getApiUrlWithVersion()}/personal_access_tokens`,
      { name },
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }

  async revoke(id: number): Promise<void> {
    await axios.delete(
      `${getApiUrlWithVersion()}/personal_access_tokens/${id}`,
      { headers: this.getAuthHeaders() }
    );
  }
}

export default new PersonalAccessTokenService();
